export default __webpack_public_path__ + "static/content-containers-light-6b0668de0965174a21c524e816c683d2.png";